import { ProjectDemoData } from './types';
import { projectA } from './project-a';
import { projectB } from './project-b';

// 新增项目：在 src/demo/projects/ 下新建项目文件后，加入此数组即可，
// 页面业务逻辑无需修改
export const demoProjects: ProjectDemoData[] = [projectA, projectB];

export const getProjectById = (id: string): ProjectDemoData | undefined =>
  demoProjects.find(project => project.id === id);

export { projectA, projectB };
export * from './types';
export { findMockResponse } from './director-engine';
